import { render, staticRenderFns } from "./pt-input.vue?vue&type=template&id=b09cd788"
import script from "./pt-input.vue?vue&type=script&lang=js"
export * from "./pt-input.vue?vue&type=script&lang=js"
import style0 from "./pt-input.vue?vue&type=style&index=0&id=b09cd788&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports